/** 경원 출하조회 규격 칸 폭 계산 (AsconSpecChips 와 짝, Fast Refresh 때문에 따로 둔 파일) */
import { asconSpec, type AsconOrder } from "@/domain/asconShipment";

/**
 * 규격 칸 폭(px) — 그날 규격 글자 중 가장 긴 것에 맞춘다. 등급 붙은 규격이 있을 때만 넓어진다(10-22 사용자 지정).
 * 칩 글꼴 = --font-mono · --fs-xs(12px): 한글 약 11.5px, 그 밖 7.2px(고정폭 0.6em) + 칩 좌우 여백 18 + 칸 여백 16(실제 좌우 20, 사용자 요청으로 4px 덜 잡음).
 * (10-22 사용자 "살짝 더 줄여도" — 한글 어림을 12.5 → 11.5 로, 이어서 "4px 더" — 여유를 38 → 34 로.
 *  등급 없음 112px · 등급 있음 142px. 넘치면 칩이 말줄임 + title)
 */
export function asconSpecColWidth(orders: Pick<AsconOrder, "kind" | "maxAgg">[]): number {
  const textW = (t: string) => [...t].reduce((a, ch) => a + (/[가-힣ㄱ-ㅎㅏ-ㅣ]/.test(ch) ? 11.5 : 7.2), 0);
  const longest = orders.reduce((m, o) => Math.max(m, textW(asconSpec(o).name)), textW("표층용(WC-2)"));
  return Math.min(240, Math.ceil(longest + 18 + 16));
}
